import * as React from 'react';
import { useState, SetStateAction } from 'react';

import * as TFF from '@tff/types/TFF';
import NskRebook from './NskRebook';

export type SelectedAmendBookings = {
  combiHashCodes: string[];
  journeyONDs: string[];
  offerPrices: string[];
};

interface props {
  orderDetails: TFF.OrderDetails;
  airports: TFF.Airport[];
  bookingSource: string;
  recordLocator: string;
  selectedAmendBookings: SelectedAmendBookings;
  setSelectedAmendBookings: (value: SetStateAction<SelectedAmendBookings>) => void;
  tfmPnr: string | undefined;
  rebookCloser: (fn: SetStateAction<boolean>) => void;
  flightDetails: TFF.FlightDetails;
  midocoOrderNo?: number;
  cancelHandler: () => void;
  retrieveDb?: TFF.Retrieve;
}

const NskRebookMain: React.FC<props> = ({
  orderDetails,
  airports,
  recordLocator,
  selectedAmendBookings,
  setSelectedAmendBookings,
  tfmPnr,
  rebookCloser,
  flightDetails,
  midocoOrderNo,
  cancelHandler,
  retrieveDb,
  bookingSource,
}) => {
  const [displayTable, setDisplayTable] = useState<boolean>(false);

  return (
    <>
      {orderDetails &&
        orderDetails.Passengers &&
        orderDetails.Journeys?.map((j: TFF.Journey, index) => {
          return (
            <NskRebook
              orderDetails={orderDetails}
              key={j.JourneyIdentifier}
              journey={j}
              airports={airports ?? []}
              bookingSource={bookingSource}
              recordLocator={recordLocator}
              selectedAmendBookings={selectedAmendBookings}
              setSelectedAmendBookings={setSelectedAmendBookings}
              tfmPnr={tfmPnr}
              rebookCloser={rebookCloser}
              flightDetails={flightDetails}
              midocoOrderNo={midocoOrderNo}
              cancelHandler={cancelHandler}
              retrieveDb={retrieveDb}
              setDisplayTable={setDisplayTable}
              displayTable={displayTable}
            />
          );
        })}
    </>
  );
};

export default NskRebookMain;
